import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmailContact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 17,
	viewBox: "0 0 23 17",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.22514 0C0.557294 0 0 0.595286 0 1.31927V15.6719C0 16.3958 0.557294 17 1.22514 17H21.7749C22.4427 17 23 16.3958 23 15.6719V1.31927C23 0.595286 22.4427 0 21.7749 0H1.22514ZM2.00107 1.13333H20.9989L11.5 9.16406L2.00107 1.13333ZM1.04545 1.75312L8.43714 8.00417L1.04545 15.1318V1.75312ZM21.9545 1.75312V15.1318L14.5629 8.00417L21.9545 1.75312ZM9.27841 8.7125L11.1815 10.324C11.2728 10.4001 11.3848 10.4413 11.5 10.4413C11.6152 10.4413 11.7272 10.4001 11.8185 10.324L13.7216 8.7125L21.146 15.8667H1.85405L9.27841 8.7125Z" })
});
export default SvgEmailContact;
